import { REMOVE_DEVICES, SET_DEVICE_DATA, SET_TOTAL_DEVICES, SET_DEVICE_CURRENT_PAGE, SET_DEVICE_PAGE_SIZE } from "../types"

const initialState = {
  devices: [],
  totalDevices: 0,
  currentPage: 1,
  pageSize: 10,
}

const deviceReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_DEVICE_DATA:
      return {
        ...state,
        devices: action.payload,
      }
    case SET_TOTAL_DEVICES:
      return {
        ...state,
        totalDevices: action.payload,
      }
    case SET_DEVICE_CURRENT_PAGE:
      return {
        ...state,
        currentPage: action.payload,
      }
    case SET_DEVICE_PAGE_SIZE:
      return {
        ...state,
        pageSize: action.payload,
      }
    case REMOVE_DEVICES:
      return {
        ...initialState
      }
    default:
      return state
  }
}

export default deviceReducer